/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { AuthenticationService } from "./authentication.service";
import { WebSocketService } from "./websocket.service";
import { Url_WebSocket_BuildUrl } from "app/rest-constants";

@Injectable()
export class EntryExitWebSocketService {

  constructor(
    private mAuthenticationService: AuthenticationService,
    private mWebSocketService: WebSocketService
  ) { }

  public create(): Subject<MessageEvent> {
    //Get information required to build URL...
    const authToken = this.mAuthenticationService.getToken();

    //Build the URL...
    const url = Url_WebSocket_BuildUrl(authToken, "locate");

    //Create the Web Socket connection / subscription and return it...
    return this.mWebSocketService.connect(url);
  }

}
